/* eslint-disable react/forbid-prop-types */
import React, { useContext, useMemo } from 'react';
import type { IScenarioContext, IActivityContext } from './types';
import { ScenarioContext } from './scenario-context';

// if no activity context is provided, defaultActivity will be used
export const ActivityContext = React.createContext<IActivityContext | undefined>(undefined);

export interface IActivityProps {
  children: React.ReactNode | React.ReactNode[];
  name?: string;
}

export const Activity: React.FC<IActivityProps> = ({ children, name }) => {
  const context = useContext(ScenarioContext) as IScenarioContext | undefined;

  const activityContext = useMemo<IActivityContext | undefined>(
    () => (context && name ? context.createActivity(name) : undefined),
    [context, name],
  );

  return (
    <ActivityContext.Provider value={activityContext}>
      {children}
    </ActivityContext.Provider>
  );
};

Activity.defaultProps = {
  name: undefined,
};
